import React, { Component } from 'react';
import { Grid, Container } from 'semantic-ui-react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';

import SavedEntriesList from './SavedEntriesList'
import { saveText } from './userActions'

const query = ({ auth }) => {
    return [
        {
            collection: 'users',
            doc: auth.uid,
            subcollections: [{ collection: 'entries' }],
            storeAs: 'entries',
            orderBy: ['created', 'desc']
        }
    ]
}

const mapStateToProps = (state, ownProps) => {
    return {
        entries: state.firestore.ordered.entries,
        auth: state.firebase.auth
    }
}

const actions = {
    saveText
}

class SavedPage extends Component {
    state = {
        textInput: ''
    }
    handleClick = () => {
        if (this.state.textInput.length == 0) {
            alert('Input is empty');
            return;
        }
        this.props.saveText(this.state.textInput);
    };
    handleChange = (e) => {
        this.setState({ [e.target.id]: e.target.value });
    };

    render() {
        var { entries } = this.props;

        return (
            <Container className="saved-page">
                <Grid className="">

                    <Grid.Column width={7}>
                        <p className="saved-page__list-title">List of saved texts</p>
                        <SavedEntriesList entries={entries} />

                    </Grid.Column>
                    <Grid.Column width={2}></Grid.Column>

                    <Grid.Column width={7}>
                        <div className="saved-page__text-container">
                            <textarea type="text" placeholder="Your text ..." className="saved-page__textInput" id="textInput" onChange={this.handleChange}></textarea>
                            <div className="saved-page__save-button" onClick={this.handleClick}>Save</div>
                        </div>

                    </Grid.Column>

                </Grid>
            </Container>
        );
    }
}


export default compose(
    connect(mapStateToProps, actions),
    firestoreConnect(
        props => query(props)
    )
)(SavedPage);


// WEBPACK FOOTER //
// ./src/Components/SavedPage/SavedPage.jsx